/**
 * Diagramm-Palette der Apartment-Auswertung.
 *
 * <p>Bis Sprint 55 war das hier ein Dark-Mode-Theme: Gitternetz zinc-800, Tooltip-Fläche
 * zinc-900, Einnahmen in Neongrün. Auf der Cream-Fläche der Marke sah das Gitter schwarz aus und
 * der Tooltip war ein dunkler Kasten mitten auf hellem Papier. Die Werte spiegeln jetzt die
 * Token aus `globals.css` — dieselbe Bauart wie `portfolioChartTheme.ts`, weil Canvas- und
 * SVG-Renderer echte Farbwerte brauchen und keine Klassen.</p>
 */
export const CHART_COLORS = {
  /** Einnahmen — sage, die Farbe für „gut gelaufen". */
  income: '#3A6F3A',
  /** Variable Ausgaben — sealwax, die Aufmerksamkeitsfarbe. */
  variable: '#A0301F',
  /** Laufende Vertragskosten — amber, klar von den variablen unterscheidbar. */
  recurring: '#E8A93A',
  axis: '#5A5648',
  grid: '#AFBEA8',
  tooltipBg: '#F8F8F4',
  /** Grau der stornierten Aufenthalte im Belegungsverlauf. */
  cancelled: '#A09A8C',
} as const;

const CHANNEL_COLORS: Record<string, string> = {
  Airbnb: '#FF5A5F',
  BookingCom: '#003580',
  Booking: '#003580',
  'Booking.com': '#003580',
  Manuell: '#E8A93A',
  Unknown: '#A09A8C',
};

/**
 * Kanalnamen kommen als Schlüssel vom Server. „BookingCom" ist ein Enum-Wert, kein Kanalname,
 * und „Unknown" ist keine Auskunft (§11: unbekannte Kanäle heißen ehrlich „Sonstige OTA").
 */
const CHANNEL_LABELS: Record<string, string> = {
  BookingCom: 'Booking.com',
  Booking: 'Booking.com',
  Unknown: 'Sonstige OTA',
};

export function channelLabel(channel: string): string {
  return CHANNEL_LABELS[channel] ?? channel;
}

export function channelColor(channel: string): string {
  const known = CHANNEL_COLORS[channel];
  if (known) return known;
  // Stabiler Fallback über einen String-Hash → derselbe Kanal bekommt immer dieselbe Farbe.
  let hash = 0;
  for (let index = 0; index < channel.length; index++) {
    hash = (hash << 5) - hash + channel.charCodeAt(index);
  }
  const palette = ['#1F3A5F', '#3A6F3A', '#A0301F', '#E8A93A', '#5A5648', '#162A3B'];
  return palette[Math.abs(hash) % palette.length] ?? CHART_COLORS.axis;
}
